import { render, staticRenderFns } from "./SubheaderListItem.vue?vue&type=template&id=c271156e&scoped=true&"
import script from "./SubheaderListItem.vue?vue&type=script&lang=js&"
export * from "./SubheaderListItem.vue?vue&type=script&lang=js&"
import style0 from "./SubheaderListItem.vue?vue&type=style&index=0&id=c271156e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c271156e",
  null
  
)

export default component.exports